import DirectRealInvestmentForm from "./DirectRealInvestmentForm";

export default DirectRealInvestmentForm;
